import axios from "axios";
import {BASE_PATH} from "../services/api";

export const getHistoryByStore = async (store_code) => {
    return axios.get(BASE_PATH + "/admin/get-history-by-store/" + store_code, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const getHistoryDates = async () => {
    return axios.get(BASE_PATH + "/admin/get-history-dates", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};
